export var ReportTab;

(function (ReportTab) {
  ReportTab["GeneralInformationReport"] = "general-information-report";
  ReportTab["QuestionReport"] = "question-report";
})(ReportTab || (ReportTab = {}));